import { useEffect } from 'react';

const styleInjection = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500;1,600&family=Courier+Prime:wght@400;700&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,700&display=swap');

  .font-serif-display { font-family: 'Cormorant Garamond', serif; }
  .font-typewriter { font-family: 'Courier Prime', monospace; }

  body {
    background-color: #F4F1EA;
    color: #1F1F1F;
    font-family: 'DM Sans', sans-serif;
    overflow-x: hidden;
  }

  .bg-noise {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    pointer-events: none;
    z-index: 50;
    opacity: 0.04;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
  }

  @keyframes rotate-slow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .spin-slow { animation: rotate-slow 30s linear infinite; }

  .text-vertical {
    writing-mode: vertical-rl;
    text-orientation: mixed;
  }

  ::-webkit-scrollbar { width: 8px; }
  ::-webkit-scrollbar-track { background: #F4F1EA; }
  ::-webkit-scrollbar-thumb { background: #D1D1C9; border-radius: 4px; }
  ::-webkit-scrollbar-thumb:hover { background: #b7eb6f; }

  .no-scrollbar::-webkit-scrollbar { display: none; }
  .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

  @keyframes bounce-slow {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  .animate-bounce-slow { animation: bounce-slow 3s ease-in-out infinite; }
`;

const GlobalStyles = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = styleInjection;
    document.head.appendChild(style);

    const phosphorScript = document.createElement('script');
    phosphorScript.src = 'https://unpkg.com/phosphor-icons';
    document.head.appendChild(phosphorScript);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return null;
};

export default GlobalStyles;
